// The NEXT_PUBLIC_ prefix is similar to the REACT_APP_ prefix from create-react-app
/**
 * Base URL of the Next.js app, e.g. http://localhost:3000 or https://share.hypotenuse.ai
 */
export const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL

/**
 * Tako server URL
 */
export const TAKO_SERVER = process.env.NEXT_PUBLIC_TAKO_SERVER

/**
 * Phoenix server URL
 */
export const PHOENIX_SERVER = process.env.NEXT_PUBLIC_PHOENIX_SERVER
